import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { toast } from "react-toastify";
import { ManageInvoicesLineItemsComp } from "../../components/Content/ManageInvoicesLineItemsComp.js";
import { useInvoiceLineItemsAPI } from "../../hooks/useInvoiceLineItemsAPI";
import { useParams } from "react-router";
import { ShimmeredDetailsList ,
  CommandBar,
  DefaultButton,
  } from "@fluentui/react";
import {
  invoiceColumns,
  onRenderColumns,
} from "../Content/InvoiceTable/utils.jsx";
import { SelectionMode } from "@fluentui/react/lib/DetailsList";
import { useQueryClient } from "react-query";
import styled from "styled-components";
import { dayDiff } from "../../utils/dateMethods.js";
import Comments from "./Comments/index.js";
const CONTROL = {
  Group: "",
  Company: "",
  Email: "",
};
const ActionBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20;
  position: sticky;
  top: 64px;
  z-index: 9;
  background-color: #fff;
`;

const LeftAction = styled.div`
  display: flex;
`;

const RightAction = styled.div`
  display: flex;
  align-items: center;
`;

const InvoiceLineItems = ({
  invoiceRecord,
  handleClose,
  setInvoiceRecord,
  handleSuccess,
  onDownLoadClick,
  onPaymentClick,
  isRoute
}) => {
  const { id } = useParams();
  const [showComment,setShowComment]=useState(false)
  const [invoiceId, setInvoiceId] = useState([]);
  const queryClient = useQueryClient();
  useEffect(() => {
    setInvoiceId(invoiceRecord.id);
  }, [invoiceRecord]);
  const SEARCH_DATA = {};
  const [page, setPage] = React.useState(1);
  const [sort, setSort] = React.useState([]);

  const [searchData, setSearchData] = React.useState({ ...SEARCH_DATA });
  const [controls, setControl] = useState({ ...CONTROL });

  const onSearch = () => {
    setPage(1);
    setSearchData({
      GroupLookupId: controls["GroupLookupId"],
      company: controls["company"],
    });
  };
  const {
    data: list,
    copyLineItems,
    dupList,
    isLoadingList,
    changedCount,
    actionDisabled,
    handleChangeValue,
    showModal,
    hideModal,
    updateMutation,
    cmInvoices
  } = useInvoiceLineItemsAPI({
    enabled: true,
    sort,
    ...searchData,
    id,
    invoiceId,
  });
  const [openModal, setOpenModal] = React.useState(false);
  const [showDisputeUpdate,setShowDisputeUpdate]=React.useState(false);
  const onEditClick = () => {
    setOpenModal(true);
  };
  const getIsUpdate = () => {
    if (dupList) {
      let isupdate =
        list?.filter((val, index) => {
          return val.isInDispute != dupList[index]?.isInDispute;
        })?.length > 0;
      return isupdate;
    }
    return false;
  };

  const changeCursor = (prevState) => {
    if (prevState === "wait") {
      document.body.style.cursor = "wait";
    } else {
      document.body.style.cursor = "default";
    }
  };

  const handlecChangeDropdown = (key, val) => {
    const copyControl = { ...controls };

    copyControl[key] = val;
    setControl((prev) => ({ ...prev, ...copyControl }));
  };
  const updateDisputeNotes = () => {
    let isError=false
    setShowDisputeUpdate(true)
    const payload = {
      lineItems: [],
    };
    list.forEach((item, index) => {
      if (
        item.isInDispute != dupList[index].isInDispute ||
        item.disputeNotes != dupList[index].disputeNotes
      ) {
        if(item.isInDispute && !item.disputeNotes) {
          isError=true
        }
        payload.lineItems.push({
          ...{
            invoiceId: invoiceRecord.id,
            lineItemId: item.itemNo,
            isInDispute: item.isInDispute,
            notes: item.disputeNotes,
            type: item.type,
            amount: item.amount,
            quantity: item.quantity,
            // isAgreement:
            //   item.type !== "tm"
            //     ? false
            //     : (item.quantity * item.amount) > 0
            //     ? true
            //     : false,
          },
        });
      }
    });

    if(isError){
      setShowDisputeUpdate(false)
      return toast.error("Please provide dispute notes for disputed items")
    }
    updateMutation.mutate(payload, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["LineItems"],
          refetchType: "all",
        });
        let newList = list.filter((i) => i.isInDispute) ?? [];
        let noDisputeAmtList = list.filter((i) => !i.isInDispute) ?? [];
        if (invoiceRecord) {
          invoiceRecord.amount_Dispute = newList
            .map((i) => i.amount)
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );
          invoiceRecord.amount_Undispute = noDisputeAmtList
            .map((i) => i.amount)
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );
          setInvoiceRecord({ ...invoiceRecord });
          handleSuccess?.(invoiceRecord);
          setTimeout(()=>{setShowDisputeUpdate(false);},500)
        }
        toast.success("Invoice updated successfully");
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong");
        changeCursor("");
        setShowDisputeUpdate(false);
      },
    });
  };
  const getListItems = (listItems) => {
    const isCMType = listItems?.filter((j) => j.type == "CM")?.length;
    return listItems?.map((i) => {
      return { ...i, isInDispute: (isCMType || cmInvoices?.length) ? false : i.isInDispute };
    });
  };

  const lineItemsChildren = () => <>      <h5 style={{ marginLeft: 16, marginTop: 8 }}>Invoice</h5>
  {dayDiff(new Date(invoiceRecord.date),new Date())>30 &&(invoiceRecord.amount_Undispute && parseFloat(invoiceRecord.amount_Undispute) > 0) &&  <div className="d-flex justify-content-end mt-4">Invoice payment due  <DefaultButton
  styles={{
    root: {
      backgroundColor: '#ffdddd',
   marginLeft:8,

    } ,
    rootHovered: {
      ':hover': {
        backgroundColor:'#ffdddd'
      },
      ':active': {
        backgroundColor:'#ffdddd'
      },
    },       
  }}
  text="Comment"
  onClick={()=>{
    setShowComment(true)
  }}
/></div>}
{showComment && <Comments showComment={showComment} setShowComment={setShowComment} invoiceRecord={invoiceRecord}></Comments>}

      <div style={{ marginLeft: 16 }}>
        <ShimmeredDetailsList
          columns={invoiceColumns({
            onEditClick: () => {},
            isDetail: true,
            onDownLoadClick,
            onPaymentClick
          }).filter((i) => i.key != "Action")}
          items={[invoiceRecord].concat(cmInvoices??[])}
        enableShimmer={isLoadingList}
        onRenderItemColumn={(item, index, column) => {
          return onRenderColumns(item, index, column, [], true);
        }}
        selectionMode={SelectionMode.none}
      ></ShimmeredDetailsList>
    </div>
    <ActionBox>
      <LeftAction>
      <h5 style={{ marginLeft: 16, marginTop: 16, marginBottom: -40,height:'44px' }}>
          Line Items
        </h5>
      </LeftAction>
      { getIsUpdate() && (
        <RightAction>
          <CommandBar
            style={{ marginLeft: 16, marginTop: 16, marginBottom: -40 }}
            items={[
              {
                key: "update",
                text: `Update`,
                iconProps: { iconName: "edit" },
                disabled:showDisputeUpdate,
                onClick: () => {
                  updateDisputeNotes?.();
                },
              },
            ]}
            ariaLabel="Inbox actions"
            primaryGroupAriaLabel="Email actions"
            farItemsGroupAriaLabel="More actions"
          />
        </RightAction>
      )}
    </ActionBox>   
    <ManageInvoicesLineItemsComp
      list={getListItems(list)}
      isLoadingList={isLoadingList}
      changedCount={changedCount}
      page={page}
      setPage={setPage}
      handleChangeValue={handleChangeValue}
      actionDisabled={actionDisabled}
      handlecChangeDropdown={handlecChangeDropdown}
      isModalOpen={openModal}
      showModal={showModal}
      hideModal={hideModal}
      sort={sort}
      setSort={setSort}
      onSearch={onSearch}
      onEditClick={onEditClick}
      copyLineItems={copyLineItems}
      isUpdateButton={getIsUpdate()}
      updateDisputeNotes={updateDisputeNotes}
      dupList={getListItems(dupList)}
      onDownLoadClick={onDownLoadClick}
      cmInvoices={cmInvoices}
      isRoute={isRoute}
      isPaymentDue={dayDiff(new Date(invoiceRecord.date),new Date())>30}
    /></>
  return (
    isRoute ? <div> {lineItemsChildren()}</div> : <Modal open={open} onClose={handleClose} isCustomize>
      {lineItemsChildren()}
    </Modal>
  );
};

export default InvoiceLineItems;
